<script>
// const serverSrc='https://service.2office.cn';
const serverSrc='http://service.2office.cn';
// const serverSrc='http://localhost:8080/canvservice';
// let serverSrc = '';
// console.log(process.env.NODE_ENV)
// if(process.env.NODE_ENV == 'development'){
    // serverSrc='http://localhost:8080/canvservice';
// }else if(process.env.NODE_ENV == 'production'){
//     serverSrc='https://service.2office.cn';
// }
// const serverSrc='http://localhost:8080/canvservice';
// const serverSrc='http://www.2office.cn:8001/canvservice';
const token='';
const hasEnter=false;
const userSite="中国钓鱼岛";
const orgId = "";
const srsxList = [
                {value: '鼠',label: '鼠'},{value: '牛',label: '牛'},{value: '虎',label: '虎'},{value: '兔',label: '兔'},
                {value: '龙',label: '龙'},{value: '蛇',label: '蛇'},{value: '马',label: '马'},{value: '羊',label: '羊'},
                {value: '猴',label: '猴'},{value: '鸡',label: '鸡'},{value: '狗',label: '狗'},{value: '猪',label: '猪'},
            ];
const srList = [
    {value: '1936',label: '1936'},{value: '1937',label: '1937'},{value: '1938',label: '1938'},{value: '1939',label: '1939'},{value: '1940',label: '1940'},{value: '1941',label: '1941'},{value: '1942',label: '1942'},{value: '1943',label: '1943'},{value: '1944',label: '1944'},{value: '1945',label: '1945'},
    {value: '1946',label: '1946'},{value: '1947',label: '1947'},{value: '1948',label: '1948'},{value: '1949',label: '1949'},{value: '1950',label: '1950'},{value: '1951',label: '1951'},{value: '1952',label: '1952'},{value: '1953',label: '1953'},{value: '1954',label: '1954'},{value: '1955',label: '1955'},
    {value: '1956',label: '1956'},{value: '1957',label: '1957'},{value: '1958',label: '1958'},{value: '1959',label: '1959'},{value: '1960',label: '1960'},{value: '1961',label: '1961'},{value: '1962',label: '1962'},{value: '1963',label: '1963'},{value: '1964',label: '1964'},{value: '1965',label: '1965'},
    {value: '1966',label: '1966'},{value: '1967',label: '1967'},{value: '1968',label: '1968'},{value: '1969',label: '1969'},{value: '1970',label: '1970'},{value: '1971',label: '1971'},{value: '1972',label: '1972'},{value: '1973',label: '1973'},{value: '1974',label: '1974'},{value: '1975',label: '1975'},
    {value: '1976',label: '1976'},{value: '1977',label: '1977'},{value: '1978',label: '1978'},{value: '1979',label: '1979'},{value: '1980',label: '1980'},{value: '1981',label: '1981'},{value: '1982',label: '1982'},{value: '1983',label: '1983'},{value: '1984',label: '1984'},{value: '1985',label: '1985'},
    {value: '1986',label: '1986'},{value: '1987',label: '1987'},{value: '1988',label: '1988'},{value: '1989',label: '1989'},{value: '1990',label: '1990'},{value: '1991',label: '1941'},{value: '1992',label: '1992'},{value: '1993',label: '1993'},{value: '1994',label: '1994'},{value: '1995',label: '1995'},
    {value: '1996',label: '1996'},{value: '1997',label: '1997'},{value: '1998',label: '1998'},{value: '1999',label: '1999'},{value: '2000',label: '2000'},{value: '2001',label: '2001'},{value: '2002',label: '2002'},{value: '2003',label: '2003'},{value: '2004',label: '2004'},{value: '2005',label: '2005'},
    {value: '2006',label: '2006'},{value: '2007',label: '2007'},{value: '2008',label: '2008'},{value: '2009',label: '2009'},{value: '2010',label: '2010'},{value: '2011',label: '2011'},{value: '2012',label: '2012'},{value: '2013',label: '2013'},{value: '2014',label: '2004'},{value: '2015',label: '2015'},
];
const xzList = [
    {value: '牡羊座(03/21-04/19)',label: '牡羊座(03/21-04/19)'},{value: '金牛座(04/20-05/20)',label: '金牛座(04/20-05/20)'},{value: '双子座(05/21-06/21)',label: '双子座(05/21-06/21)'},{value: '巨蟹座(06/22-07/22)',label: '巨蟹座(06/22-07/22)'},{value: '狮子座(07/23-08/22)',label: '狮子座(07/23-08/22)'},{value: '处女座(08/23-09/22)',label: '处女座(08/23-09/22)'},
    {value: '天秤座(09/23-10/23)',label: '天秤座(09/23-10/23)'},{value: '天蝎座(10/24-11/21)',label: '天蝎座(10/24-11/21)'},{value: '射手座(11/22-12/21)',label: '射手座(11/22-12/21)'},{value: '魔羯座(12/22-01/19)',label: '魔羯座(12/22-01/19)'},{value: '水瓶座(01/20-02/18)',label: '水瓶座(01/20-02/18)'},{value: '双鱼座(02/19-03/20)',label: '双鱼座(02/19-03/20)'},
];
const ahList = [
    {value:'美食',label:'美食'},{value:'唱歌',label:'唱歌'},{value:'跳舞',label:'跳舞'},{value:'电影',label:'电影'},{value:'音乐',label:'音乐'},
    {value:'戏剧',label:'戏剧'},{value:'聊天',label:'聊天'},{value:'模型',label:'模型'},{value:'电脑',label:'电脑'},{value:'赚钱',label:'赚钱'},
    {value:'上网',label:'上网'},{value:'游戏',label:'游戏'},{value:'绘画',label:'绘画'},{value:'书法',label:'书法'},{value:'雕塑',label:'雕塑'},
    {value:'锻炼',label:'锻炼'},{value:'旅行',label:'旅行'},{value:'政治',label:'政治'},{value:'宗教',label:'宗教'},{value:'购物',label:'购物'},
];
const xlList = [
    {value:'中专',label:'中专'},{value:'大学',label:'大学'},{value:'本科',label:'本科'},
    {value:'硕士',label:'硕士'},{value:'博士',label:'博士'},{value:'博士后',label:'博士后'},
];
const zzhyList = [
    {value:'互联网/电子商务',label:'互联网/电子商务'},{value:'计算机硬件',label:'计算机硬件'},{value:'计算机软件',label:'计算机软件'},{value:'集成电路',label:'集成电路'},{value:'电子',label:'电子'},
    {value:'计算机外设',label:'计算机外设'},{value:'光电通信',label:'光电通信'},{value:'光学精密',label:'光学精密'},{value:'通讯',label:'通讯'},{value:'电机电工',label:'电机电工'},
    {value:'多媒体',label:'多媒体'},{value:'制药/医疗设备/生物工程',label:'制药/医疗设备/生物工程'},{value:'仪器/仪表/工业自动化',label:'仪器/仪表/工业自动化'},{value:'金融/投资/证券',label:'金融/投资/证券'},{value:'法律/会计',label:'法律/会计'},
    {value:'人才中介',label:'人才中介'},{value:'咨询/专业服务',label:'咨询/专业服务'},{value:'市场/广告/公关',label:'市场/广告/公关'},{value:'广播/影视',label:'广播/影视'},{value:'传媒/新闻出版',label:'传媒/新闻出版'},
    {value:'保险业',label:'保险业'},{value:'建筑/房地产',label:'建筑/房地产'},{value:'物业管理',label:'物业管理'},{value:'娱乐/运动/休闲',label:'娱乐/运动/休闲'},{value:'批发/零售',label:'批发/零售'},
    {value:'医疗/保健/卫生服务',label:'医疗/保健/卫生服务'},{value:'旅游/酒店/餐饮服务',label:'旅游/酒店/餐饮服务'},{value:'贸易',label:'贸易'},{value:'运输/物流/快递',label:'运输/物流/快递'},{value:'艺术/文化',label:'艺术/文化'},
    {value:'中介/服务业',label:'中介/服务业'},{value:'机械/机电/重工业',label:'机械/机电/重工业'},{value:'食品/饮料/烟酒',label:'食品/饮料/烟酒'},{value:'办公/文教/安防',label:'办公/文教/安防'},{value:'农林畜牧渔',label:'农林畜牧渔'},
    {value:'五金/金属制品业',label:'五金/金属制品业'},{value:'环保',label:'环保'},{value:'化工/橡塑/精细化工',label:'化工/橡塑/精细化工'},{value:'纺织/服装/服饰',label:'纺织/服装/服饰'},{value:'车辆/机械动力',label:'车辆/机械动力'},
    {value:'家具/室内设计/装潢',label:'家具/室内设计/装潢'},{value:'玻璃/陶瓷',label:'玻璃/陶瓷'},{value:'家电业',label:'家电业'},{value:'工艺品/玩具',label:'工艺品/玩具'},{value:'纸品/印刷/包装',label:'纸品/印刷/包装'},
    {value:'电力/电气/能源',label:'电力/电气/能源'},{value:'矿产/冶金',label:'矿产/冶金'},{value:'其它制造',label:'其它制造'},{value:'培训机构/教育/科研院所',label:'培训机构/教育/科研院所'},{value:'政府/公共事业',label:'政府/公共事业'},
    {value:'非盈利机构(协会/社团)',label:'非盈利机构(协会/社团)'},
];
const zwList = [
    {value:'经营管理',label:'经营管理'},{value:'项目管理',label:'项目管理'},{value:'人力资源',label:'人力资源'},{value:'行政后勤',label:'行政后勤'},{value:'财务/审计',label:'财务/审计'},
    {value:'信息/资料管理',label:'信息/资料管理'},{value:'工程师(计算机硬件)',label:'工程师(计算机硬件)'},{value:'工程师(计算机软件)',label:'工程师(计算机软件)'},{value:'工程师(计算机网络)',label:'工程师(计算机网络)'},{value:'工程师(系统与安全)',label:'工程师(系统与安全)'},
    {value:'工程师(其他)',label:'工程师(其他)'},{value:'工程/技术助理',label:'工程/技术助理'},{value:'网站管理/策划/设计',label:'网站管理/策划/设计'},{value:'建筑/园林/室内设计',label:'建筑/园林/室内设计'},{value:'商业设计/创意',label:'商业设计/创意'},{value:'研发',label:'研发'},
    {value:'生产管理',label:'生产管理'},{value:'工程管理',label:'工程管理'}, {value:'生产工艺/设备',label:'生产工艺/设备'},{value:'质量控制',label:'质量控制'},{value:'技工/施工/操作人员',label:'技工/施工/操作人员'},{value:'工程造价/预决算',label:'工程造价/预决算'},
    {value:'农林牧渔',label:'农林牧渔'},{value:'市场营销/商务拓展',label:'市场营销/商务拓展'},{value:'市场调查与分析',label:'市场调查与分析'},{value:'广告/公关/媒介',label:'广告/公关/媒介'},{value:'销售/贸易',label:'销售/贸易'},{value:'报关/跟单',label:'报关/跟单'},
    {value:'电子商务',label:'电子商务'},    {value:'客户服务',label:'客户服务'},    {value:'采购',label:'采购'},    {value:'运输/物流/仓储',label:'运输/物流/仓储'},    {value:'金融保险专业人员',label:'金融保险专业人员'},    {value:'金融保险经纪人',label:'金融保险经纪人'},
    {value:'律师/法务人员',label:'律师/法务人员'},    {value:'猎头/人才中介',label:'猎头/人才中介'},    {value:'顾问',label:'顾问'},    {value:'策划',label:'策划'},    {value:'培训师',label:'培训师'},    {value:'翻译',label:'翻译'},    {value:'记者/新闻工作者',label:'记者/新闻工作者'},
    {value:'编辑/文字/文案',label:'编辑/文字/文案'},    {value:'传播/发行',label:'传播/发行'},
    {value:'文艺制作',label:'文艺制作'},
    {value:'演艺人员',label:'演艺人员'},
    {value:'演艺/体育经纪人',label:'演艺/体育经纪人'},
    {value:'导游',label:'导游'},
    {value:'教练/运动员',label:'教练/运动员'},
    {value:'医生/医师/护理人员',label:'医生/医师/护理人员'},
    {value:'美容/保健/营养师',label:'美容/保健/营养师'},
    {value:'兽医/动物管理/园艺',label:'兽医/动物管理/园艺'},
    {value:'安全保卫',label:'安全保卫'},
    {value:'服务业管理',label:'服务业管理'},
    {value:'服务业技术人员',label:'服务业技术人员'},
    {value:'服务人员',label:'服务人员'},
    {value:'教师/教育工作者',label:'教师/教育工作者'},
    {value:'义工/社团工作者',label:'义工/社团工作者'},
    {value:'公务员',label:'公务员'},
    {value:'私营企业主',label:'私营企业主'},
    {value:'自由职业者',label:'自由职业者'},
    {value:'培训生',label:'培训生'},
    {value:'在校学生"',label:'在校学生"'},
];
const jszcList = [
    {value:'教师系列',label:'教师系列'},{value:'实验系列',label:'实验系列'},{value:'研究员系列',label:'研究员系列'},{value:'工程系列',label:'工程系列'},{value:'经济师系列',label:'经济师系列'},
    {value:'会计师系列',label:'会计师系列'},{value:'统计师系列',label:'统计师系列'},{value:'审计师系列',label:'审计师系列'},{value:'医师系列',label:'医师系列'},{value:'记者系列',label:'记者系列'},
    {value:'翻译系列',label:'翻译系列'},{value:'律师系列',label:'律师系列'},{value:'其他',label:'其他'},
];
const technicals = [
    {value:'教师系列',label:'教师系列'},
    {value:'实验系列',label:'实验系列'},
    {value:'研究员系列',label:'研究员系列'},
    {value:'工程系列',label:'工程系列'},
    {value:'经济师系列',label:'经济师系列'},
    {value:'会计师系列',label:'会计师系列'},
    {value:'统计师系列',label:'统计师系列'},
    {value:'审计师系列',label:'审计师系列'},
    {value:'医师系列',label:'医师系列'},
    {value:'记者系列',label:'记者系列'},
    {value:'翻译系列',label:'翻译系列'},
    {value:'律师系列',label:'律师系列'},
    {value:'其他',label:'其他'},
];
const allPositions = [
    {technical:'教师系列',label:'教授'},{technical:'教师系列',label:'副教授'},{technical:'教师系列',label:'讲师'},{technical:'教师系列',label:'助教'},
    {technical:'实验系列',label:'高级实验师'},{technical:'实验系列',label:'实验师'},{technical:'实验系列',label:'助理实验师'},{technical:'实验系列',label:'实验员'},
    {technical:'研究员系列',label:'研究员'},{technical:'研究员系列',label:'副研究员'},{technical:'研究员系列',label:'助理研究员'},{technical:'研究员系列',label:'研究实习员'},
    {technical:'工程系列',label:'高级工程师'},{technical:'工程系列',label:'工程师'},{technical:'工程系列',label:'助理工程师'},{technical:'工程系列',label:'技术员'},
    {technical:'经济师系列',label:'高级经济师'},{technical:'经济师系列',label:'经济师'},{technical:'经济师系列',label:'助理经济师'},{technical:'经济师系列',label:'经济员'},
    {technical:'会计师系列',label:'高级会计师'},{technical:'会计师系列',label:'会计师'},{technical:'会计师系列',label:'助理会计师'},{technical:'会计师系列',label:'会计员'},
    {technical:'统计师系列',label:'高级统计师'},{technical:'统计师系列',label:'统计师'},{technical:'统计师系列',label:'助理统计师'},{technical:'统计师系列',label:'统计员'},
    {technical:'审计师系列',label:'高级审计师'},{technical:'审计师系列',label:'审计师'},{technical:'审计师系列',label:'助理审计师'},{technical:'审计师系列',label:'审计员'},
    {technical:'医师系列',label:'主任医师'},{technical:'医师系列',label:'副主任医师'},{technical:'医师系列',label:'主治医师'},{technical:'医师系列',label:'医师'},{technical:'医师系列',label:'医士'},
    {technical:'记者系列',label:'高级记者'},{technical:'记者系列',label:'主任记者'},{technical:'记者系列',label:'记者'},{technical:'记者系列',label:'助理记者'},
    {technical:'翻译系列',label:'译审'},{technical:'翻译系列',label:'副译审'},{technical:'翻译系列',label:'翻译'},{technical:'翻译系列',label:'助理翻译'},
    {technical:'律师系列',label:'一级律师'},{technical:'律师系列',label:'二级律师'},{technical:'三级律师',label:'讲师'},{technical:'律师系列',label:'四级律师'},{technical:'律师系列',label:'律师助理'},
    {technical:'其他',label:'高级'},{technical:'其他',label:'副高级'},{technical:'其他',label:'中级'},{technical:'其他',label:'助理级'},{technical:'其他',label:'员级'},
];
const zldjList = [
    {value:'初期阶段(2年以内工作经验)',label:'初期阶段(2年以内工作经验)'},
    {value:'中级阶段(2-5年工作经验)',label:'中级阶段(2-5年工作经验)'},
    {value:'高级阶段(5年以上工作经验/经理或专才)',label:'高级阶段(5年以上工作经验/经理或专才)'},
    {value:'高级管理级别(CEO, EVP, GM)',label:'高级管理级别(CEO, EVP, GM)'},
]
 export default
 {
  userSite,//用户地址
  token,//用户token身份
  serverSrc,//服务器地址
  hasEnter,//用户登录状态
  srsxList, //十二生肖
  srList, //生日
  xzList, //星座
  ahList, //爱好
  xlList, //学历
  zzhyList, //在职行业
  zwList, //职位
  jszcList, //技术职称
  technicals,
  allPositions,
  zldjList, //资历等级
 }
</script>


// WEBPACK FOOTER //
// src/components/Global.vue